import React, {useEffect} from 'react'
import {Box, Card, Button} from '@material-ui/core'
import useStyles from './BarcodeWizardSheetPreview.styles'
const BOX_SIZE = 35
const MARGIN_SIZE = 5

function BarcodeWizardSheetPreview({sheetRecord, page, startPosition, onClickButton}) {
  const classes = useStyles()
  const [eventHandler, setEventHandler] = React.useState(undefined)
  const {columns, rows} = sheetRecord
  const cardWidth = (BOX_SIZE - MARGIN_SIZE) / columns
  const cardHeight = (BOX_SIZE - MARGIN_SIZE) / rows

  function handleClick(event, maxPosition) {
    event.currentTarget.style.borderColor = 'blue'
    onClickButton(event.currentTarget.value, maxPosition)
    if (eventHandler !== undefined && eventHandler !== event.currentTarget) {
      eventHandler.style.borderColor = 'LightGray'
    }
    setEventHandler(event.currentTarget)
  }

  useEffect(() => {
    if (startPosition && document.getElementById('button' + startPosition)) {
      document.getElementById('button' + startPosition).click()
    }
  }, [startPosition])

  const cards = []
  let counter = 1

  for (let i = 0; i < rows; i++) {
    const cardRows = []

    for (let j = 0; j < columns; j++, counter++) {
      cardRows.push({
        marginRight: j !== columns - 1 ? MARGIN_SIZE / (columns - 1) : 0,
        counter: counter,
      })
    }
    cards.push({
      marginBottom: i !== rows - 1 ? MARGIN_SIZE / (rows - 1) : 0,
      cardRows: cardRows,
    })
  }

  return (
    <Box bgcolor="background.paper" m={8} className={classes.root}>
      {cards.map((card, i) => (
        <div
          key={`i${i}`}
          style={{
            height: `${cardHeight}rem`,
            marginBottom: `${card.marginBottom}rem`,
          }}
        >
          {card.cardRows.map((cardRow, j) =>
            page !== 'generate' ? (
              <Card
                key={`j${j}`}
                className={classes.cardRow}
                style={{
                  width: `${cardWidth}rem`,
                  height: `${cardHeight}rem`,
                  marginRight: `${cardRow.marginRight}rem`,
                }}
              />
            ) : (
              <Button
                id={'button' + cardRow.counter}
                className={classes.cardRow}
                style={{
                  width: `${cardWidth}rem`,
                  height: `${cardHeight}rem`,
                  marginRight: `${cardRow.marginRight}rem`,
                }}
                onClick={e => handleClick(e, cardRow.counter)}
                value={cardRow.counter}
                key={`counter${cardRow.counter}`}
                classes={{label: classes.btnText}}
              >
                {cardRow.counter}
              </Button>
            )
          )}
        </div>
      ))}
    </Box>
  )
}

export default BarcodeWizardSheetPreview
